import { ICabinMainCategoryToCabinType } from './interfaces'

export class CabinMainCategoryToCabinType {
  BE = this.CabinMainCategoryToCabinType_Default
  BL = this.CabinMainCategoryToCabinType_Default
  DI = this.CabinMainCategoryToCabinType_Default
  LU = this.CabinMainCategoryToCabinType_Default
  MA = this.CabinMainCategoryToCabinType_Default
  SO = this.CabinMainCategoryToCabinType_Default
  ST = this.CabinMainCategoryToCabinType_Default
  PE = this.CabinMainCategoryToCabinType_PE_PR
  PR = this.CabinMainCategoryToCabinType_PE_PR
  NO = this.CabinMainCategoryToCabinType_NO
  CO = this.CabinMainCategoryToCabinType_CO

  get CabinMainCategoryToCabinType_Default() {
    const cabins: ICabinMainCategoryToCabinType = {
      I: 'Innenkabine',
      M: 'Meerblickkabine',
      B: 'Balkonkabine',
      P: 'Balkonkabine',
      V: 'Verandakabine',
      J: 'Suite',
      S: 'Suite',
    }

    return cabins
  }

  get CabinMainCategoryToCabinType_PE_PR() {
    const cabins: ICabinMainCategoryToCabinType = {
      I: 'Innenkabine',
      M: 'Meerblickkabine',
      B: 'Balkonkabine',
      V: 'Verandakabine',
      P: 'Verandakabine',
      K: 'Verandakabine',
      D: 'Verandakabine',
      L: 'Verandakabine',
      J: 'Suite',
      S: 'Suite',
    }

    return cabins
  }

  get CabinMainCategoryToCabinType_NO() {
    const cabins: ICabinMainCategoryToCabinType = {
      I: 'Innenkabine',
      M: 'Meerblickkabine',
      B: 'Balkon-/Verandakabine',
      V: 'Balkon-/Verandakabine',
      K: 'Balkon-/Verandakabine',
      D: 'Balkon-/Verandakabine',
      J: 'Suite',
      S: 'Suite',
    }

    return cabins
  }

  get CabinMainCategoryToCabinType_CO() {
    const cabins: ICabinMainCategoryToCabinType = {
      I: 'Innenkabine',
      M: 'Meerblickkabine',
      B: 'Balkon-/Verandakabine',
      V: 'Balkon-/Verandakabine',
      K: 'Balkon-/Verandakabine',
      D: 'Balkon-/Verandakabine',
      J: 'Suite',
      S: 'Suite',
    }

    return cabins
  }
}